import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ui-user-menu',
  templateUrl: './ui-user-menu.component.html',
  styleUrls: ['./ui-user-menu.component.scss']
})
export class UiUserMenuComponent {
  @Input() userName = 'Admin';
  @Input() companyName = '';
  @Input() initials = 'AD';
  @Output() logout = new EventEmitter<void>();

  onLogout(): void {
    this.logout.emit();
  }
}
